/* ==========================================================================
   duvelle-ugc-video.js
   Comportement des videos UGC : lecture automatique au defilement, son coupe,
   boucle infinie, aucune barre de progression, seule la pause est possible.
   Les libelles proviennent d'attributs data-* remplis en Liquid, donc
   traduisibles via Translate & Adapt.
   ========================================================================== */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function refreshState(video) {
    var media = video.closest('.dv-ugc__media');
    if (!media) return;
    var playing = !video.paused && !video.ended;
    media.setAttribute('data-playing', playing ? 'true' : 'false');

    var button = media.querySelector('[data-dv-video-toggle]');
    if (!button) return;
    var label = playing ? button.getAttribute('data-label-pause') : button.getAttribute('data-label-play');
    if (label) button.setAttribute('aria-label', label);
    button.setAttribute('aria-pressed', playing ? 'true' : 'false');
  }

  function safePlay(video) {
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        /* Certains navigateurs refusent la lecture automatique : on laisse
           simplement le bouton de lecture visible. */
      });
    }
  }

  function initVideo(video) {
    if (video.getAttribute('data-dv-init') === 'true') return;
    video.setAttribute('data-dv-init', 'true');

    /* Verrouillage du comportement, quels que soient les attributs rendus
       par le filtre video_tag. */
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.controls = false;
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.removeAttribute('controls');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('disablepictureinpicture', '');
    video.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');

    video.addEventListener('play', function () {
      refreshState(video);
    });
    video.addEventListener('pause', function () {
      refreshState(video);
    });

    refreshState(video);

    var media = video.closest('.dv-ugc__media');
    var autoplay = !media || media.getAttribute('data-autoplay') !== 'false';

    if (!autoplay || reducedMotion.matches || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            if (video.getAttribute('data-dv-user-paused') === 'true') return;
            safePlay(video);
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { threshold: [0, 0.5] }
    );

    observer.observe(video);
    video.dvObserver = observer;
  }

  function initToggle(button) {
    if (button.getAttribute('data-dv-init') === 'true') return;
    button.setAttribute('data-dv-init', 'true');

    button.addEventListener('click', function () {
      var media = button.closest('.dv-ugc__media');
      var video = media && media.querySelector('video');
      if (!video) return;

      if (video.paused) {
        video.setAttribute('data-dv-user-paused', 'false');
        safePlay(video);
      } else {
        video.setAttribute('data-dv-user-paused', 'true');
        video.pause();
      }
    });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.dv-ugc__media video').forEach(initVideo);
    scope.querySelectorAll('.dv-ugc__media [data-dv-video-toggle]').forEach(initToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  /* Editeur de theme : reinitialisation apres ajout, deplacement ou
     rechargement d'une section, sans jamais dupliquer un ecouteur. */
  if (!window.__duvelleUgcVideoBound) {
    window.__duvelleUgcVideoBound = true;

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('.dv-ugc__media video').forEach(function (video) {
        if (video.dvObserver) video.dvObserver.disconnect();
      });
    });
  }
})();
